import React, { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { HiOutlineArrowLeft, HiPlus, HiOutlinePencil } from "react-icons/hi";

import { productionSetupService } from "../../services/productionSetupservice";

import ProductionSetupScroll from "./ProductionSetupScroll";
import ProductionSetupDetailContent from "./ProductionSetupDetailContent";
import { SetProdSetUpAtomData, GetProdSetUpAtomData } from "../../store/productionSetupAtom";
import { isArray } from "lodash";


export default function ProductionSetupDetailsPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const [details, setDetails] = useState({});
  const [setupList, setSetupList] = useState([]);
  const [loading, setLoading] = useState(false);
      const getProdSetupAtom = GetProdSetUpAtomData();
         const setProdSetupAtom = SetProdSetUpAtomData();

  const currModuleId = pathname.split("/")[1];
  const currModuleName = pathname.split("/")[2];
  const currUserMenu = pathname.split("/")[3];

  useEffect(() => {
    document.title = "Production Setup | Details";
    if (id) {
      loadDetails(id);
    }
  }, [id]);




    useEffect(()=> {
        if(!getProdSetupAtom?.production_item_info?.length){
         loadDataFromServer();
        }
  
    },[getProdSetupAtom]);


     const loadDataFromServer = ()=>{
        productionSetupService.getProductionSetupList().then((res)=> {
          if( isArray(res?.data?.production_item_info) && res?.data?.production_item_info?.length){
            setProdSetupAtom(res.data);
          }
         }).catch((err)=> {
          console.log(err);
         });
      }


  const loadDetails = async (setupId) => {
    setLoading(true);
    try {
      const response = await productionSetupService.productionDetails(setupId);
      const { required_item_info, production_item_info } = response.data || {};

      if (Array.isArray(required_item_info) && required_item_info.length) {
        setSetupList(required_item_info);
      } else {
        setSetupList([]);
      }

      if (Array.isArray(production_item_info) && production_item_info.length) {
        setDetails(production_item_info[0]);
      } else {
        setDetails({});
      }
    } catch (err) {
      console.error("Failed to load production setup details:", err);
      // Optionally show toast/notification here
    } finally {
      setLoading(false);
    }
  };

  const goBack = () => navigate(-1);

  const goToEditProductionSetup = () => {
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new?productionId=${id}`);
  };

  const goToNewSetup = () => {
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`);
  };

  const handleProductSelect = (item) => {
    const selectedId = item?.Item_Id;
    if (selectedId && selectedId !== id) {
      navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${selectedId}`);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Sticky Header */}
      <div className="sticky top-0 z-20 bg-white border-b shadow-sm">
        <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center gap-4">
              <button
                onClick={goBack}
                className="p-2 rounded-lg hover:bg-gray-100 text-gray-600 hover:text-gray-900 transition-colors"
                title="Go back"
              >
                <HiOutlineArrowLeft size={20} />
              </button>
              <h1 className="text-xl font-semibold text-gray-900">
                Production Setup
              </h1>
              {id && (
                <span className="text-sm text-gray-500 font-mono">#{id}</span>
              )}
            </div>

            <div className="flex items-center gap-3">
              <button
                onClick={goToNewSetup}
                className="inline-flex items-center gap-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg transition-colors shadow-sm"
              >
                <HiPlus size={18} />
                New Setup
              </button>

              <button
                onClick={goToEditProductionSetup}
                className="inline-flex items-center gap-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg transition-colors shadow-sm"
              >
                <HiOutlinePencil size={18} />
                Edit Setup
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Main Layout */}
      <div className="flex flex-1 overflow-hidden">
        {/* Left Sidebar - List of Setups */}
        <aside className="w-20 xl:w-20 flex-shrink-0 border-r bg-white overflow-hidden">
          <div className="h-full">
            <ProductionSetupScroll
              onSelect={handleProductSelect}
              activeId={id}
            />
          </div>
        </aside>

        {/* Main Content Area */}
        <main className="flex-1 overflow-y-auto bg-gray-50">
          <div className="max-w-[1400px] mx-auto p-6 lg:p-8">
            {loading ? (
              <div className="flex items-center justify-center h-64">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
              </div>
            ) : (
              <ProductionSetupDetailContent
                details={details}
                setupList={setupList}
                goToEditProductionSetup={goToEditProductionSetup}
                onNewSetUp={goToNewSetup}
              />
            )}
          </div>
        </main>
      </div>
    </div>
  );
}